import { Component } from "react";
import { connect } from "react-redux";
import {
    submitOrEditAnalyseRisques,
    deleteArOrPps,
} from "../../../redux/analyseRisques/analyseRisquesEditionActions";
import { withRouter } from "react-router-dom";
import { compose } from "redux";
import Icon from "@mui/material/Icon/Icon";
import Fab from "@mui/material/Fab";
import "../../../utils.css";
import FooterFixedOnScreen from "../../../containers/Layout/FooterFixedOnScreen";

class NewAnalyseRisques extends Component {
    submitOrEditAnalyseRisques() {
        this.props.submitOrEditAnalyseRisques(
            this.props.analyseRisques,
            this.props.activeUser,
            this.props.analysesRisques.moduleSpp,
            this.props.riskTypes,
            this.props.analysesRisques
        );
    }

    deleteArOrPps() {
        this.props.deleteArOrPps(
            this.props.analyseRisques,
            this.props.activeUser,
            this.props.analysesRisques
        );
    }

    render() {
        let deleteBtnElement = (
            <div>
                <Fab
                    onClick={this.deleteArOrPps.bind(this)}
                    className="red-button div-center"
                >
                    <Icon>delete</Icon>
                </Fab>
                <span className="floating-btn-text span-center">
                    Supprimer
                </span>
            </div>
        );
        let validationBtnLabel = "Valider";

        if (this.props.analyseRisques.header.validationInProgress) {
            validationBtnLabel = "Renvoyer validation";
        }

        return (
            <FooterFixedOnScreen>
                <div className="row">
                    <div className="col-lg-2 col-md-2 col-sm-4 col-4">
                        {deleteBtnElement}
                    </div>
                    <div className="offset-lg-8 col-lg-2 offset-md-8 col-md-2 offset-sm-4 col-sm-4 offset-4 col-4">
                        <div className="center">
                            <Fab
                                onClick={this.submitOrEditAnalyseRisques.bind(
                                    this
                                )}
                                color="primary"
                                className="div-center"
                            >
                                <Icon>send</Icon>
                            </Fab>
                            <span className="floating-btn-text span-center">
                                {validationBtnLabel}
                            </span>
                        </div>
                    </div>
                </div>
            </FooterFixedOnScreen>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        analyseRisques: state.analyseRisques,
        analysesRisques: state.analysesRisques,
        riskTypes: state.riskTypes.types,
        activeUser: state.activeUser,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        submitOrEditAnalyseRisques: (
            analyseRisques,
            activeUser,
            moduleSpp,
            riskTypes,
            analysesRisquesState
        ) =>
            dispatch(
                submitOrEditAnalyseRisques(
                    analyseRisques,
                    activeUser,
                    moduleSpp,
                    riskTypes,
                    analysesRisquesState
                )
            ),
        deleteArOrPps: (analyseRisques, activeUser, analysesRisquesState) =>
            dispatch(
                deleteArOrPps(analyseRisques, activeUser, analysesRisquesState)
            ),
    };
};

export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
)(NewAnalyseRisques);
